<template>
  <div class="modal_projects">
    <div class="modal_projects__header">
      <h4 class="title">
        {{ translate("project.new") }}
      </h4>
    </div>

    <div class="modal_projects__body">
      <div class="project">
        <div class="block">
          <div class="block_wrap">

            <div class="line">
              <div class="input_wrap main_name">
                <fg-input
                    v-model="primary_data.name"
                    type="text"
                    :label="translate('project.name')"
                    :placeholder="translate('project.name')"
                />
              </div>
              <div class="input_wrap parent_company">
                <label>
                  {{ translate('project.client') }}
                </label>
                <tree-select
                    :options="client_list"
                    :placeholder="translate('project.client')"
                    v-model="primary_data.client_id"
                    :clearable="false"
                    :multiple="false"
                />
              </div>
            </div>

            <div class="line">
              <div class="input_wrap">
                <label> {{ translate('project.status') }} </label>
                <tree-select
                    v-model="primary_data.status"
                    :options="status_list"
                    :placeholder="translate('project.status')"
                    :clearable="false"
                    :searchable="false"
                    :disabled="true"
                />
              </div>

              <div class="input_wrap">
                <label> {{ translate('project.priority') }} </label>
                <tree-select
                    v-model="primary_data.priority"
                    :options="priority_list"
                    :placeholder="translate('project.priority')"
                    :clearable="false"
                    :searchable="false"
                />
              </div>
            </div>

            <div class="line">
              <div class="text_wrap">
                <div class="form-group">
                  <label>{{ translate('project.description') }}</label>
                  <textarea class="input_text" name="description" v-model="primary_data.description"/>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="modal_projects__footer">
      <span
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="create_project"
      >
        {{ translate('btn.create') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </span>
    </div>

  </div>
</template>
<script>



export default {
  name: 'ProjectModal',
  components: { },
  data () {
    return {
      primary_data: {
        id: null,
        name: "",
        description: '',
        client_id: null,
        status: 0,
        priority: 0
      },
      loading: true,
      filter_link: null
    }
  },
  computed:{
    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        return {label: client.name, id: client.id}
      })
    },

    status_list(){
      return this.$store.getters.getProjectInfo.statuses.map((entry) => {
        return {id: entry.id, label: entry.title}
      })
    },

    priority_list(){
      return this.$store.getters.getProjectInfo.prioritys.map((entry) => {
        return {id: entry.id, label: entry.title}
      })
    },
  },

  methods: {
    create_project(){
      this.$http.v1.createProject(this.primary_data, (response) => {
        this.global_notify('info', this.translate('project.created_success'))
        this.$emit('update', response.data.project.id)
      })
    },
    close_modal () {
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .modal_projects{
    height: 100%;
    padding: 10px;
    &__header{
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .title{
        width: 100%;
        margin: 0;
        text-align: center;
      }
      .links{
        width: 30%;
        & > .vue-treeselect{
          margin-bottom: 0;
        }
      }
    }
    &__body{
      width: 100%;
      //height: 100%;
      height: 600px;
      .project{
        width: 100%;
        height: 100%;
        .block{
          height: calc(100% - 35px);
          border: 1px solid #efe9e9;
          margin-top: -1px;
          padding: 10px;
          overflow-y: auto;
          .input_wrap{
            text-align: start;
            margin-bottom: 10px;
          }
          .text_wrap{
            text-align: start;
          }
          &::-webkit-scrollbar{
            width: 10px;
          }
        }
      }

    }
    &__footer{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      .btn{
        margin: 0 10px 0 0;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }
  .form-group,
  .vue-treeselect{
    margin-bottom: 0;
  }


</style>
